
import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import Quill from 'quill';
import { installQuillNbspFix } from './quill-nbsp-fix';

installQuillNbspFix();

@Component
export default class Code extends Vue {
  @Prop({ required: true })
  value!: string;

  quill: Quill | null = null;

  mounted(): void {
    this.quill = new Quill(this.$refs.el! as HTMLElement, {
      theme: 'snow',
    });
    this.quill.on('text-change', () => {
      this.$emit('input', this.quill!.getSemanticHTML());
    });
    this.onValueChanged();
  }

  @Watch('value', { immediate: true })
  onValueChanged(): void {
    if (!this.quill) {
      return;
    }

    if (this.value === this.quill!.getSemanticHTML()) {
      return;
    }

    this.quill!.clipboard.dangerouslyPasteHTML(this.value);
  }
}
